import { useQuery } from "hooks/useQuery";
import { getPortfolioPositions } from "features/Dashboard/service";

export const usePositionsData = (portfolioId) => {
  const { isLoading, data } = useQuery({
    key: "portfolioPositions",
    queryKey: ["portfolioPositions", portfolioId],
    queryFn: async () => {
      const response = await getPortfolioPositions(portfolioId);
      return response;
    },
  });

  return {
    isLoading,
    positionsData: data || [],
  };
};
